export const ArpeggioPadsRow = props => {
  const edition = props.edition

  const activeBtnsArr = props.activeBtns
  const padsIndexes = props.padsIndexes

  const activePads = activeBtnsArr.map(item => {
    if (item) return true
    return false
  })

  const activeCursorArr = props.activeCursor

  const activeCursorOnPads = activeCursorArr.map(item => {
    if (item) return true
    return false
  })

  const justCleared = props.justCleared

  const padClassNameArr = []

  for (let i = 0; i < activePads.length; i++) {
    padClassNameArr.push("arpeggioPad noContextMenu pointerHover")
  }

  for (let i = 0; i < activePads.length; i++) {
    if (justCleared[i]) padClassNameArr[i] += " arpeggioJustCleared"
    else {
      switch(edition) {
        case "prototype":
          if (activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " activeWithCursorArpeggioPrototype"
          else if (activePads[i] && !activeCursorOnPads[i]) padClassNameArr[i] += " activeWithoutCursorArpeggioPrototype"
          else if (!activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " inactiveWithCursorSArpeggioPrototype"
          else padClassNameArr[i] += " inactiveWithoutCursorArpeggioPrototype"
          break

        default: break
      }
    }
  }

  const stepsArr = []

  for (let i = 1; i <= props.stepsAmount; i++) {
    stepsArr.push(i)
  }

  let dataPadsType = ""
  let padsContainer = ""
  switch(props.padsType) {
    case "instruments":
      padsContainer = document.getElementById("arpeggioInstrumentsPadsCardContainer")
      dataPadsType = "instruments"
      break

    case "drums":
      padsContainer = document.getElementById("arpeggioDrumsPadsCardContainer") 
      dataPadsType = "drums"
      break

    default: break
  }

  let padWidth = ""
  if (padsContainer !== null) padWidth = (padsContainer.clientWidth / activeBtnsArr.length) - 2

  return (
      <div className="arpeggioRowContainer" data-action="togglePadStatus"> 
          {stepsArr.map((step, index) => {
            return (
              <div type="button" className={padClassNameArr[index]} data-row={padsIndexes[index].row} data-col={padsIndexes[index].col}  key={step} onClick={props.handleClick}  style={{width: padWidth}} data-padstype={dataPadsType} />
            )
          })}
      </div>
  )
}